import React from "react";
import { useState } from "react";
export default function Card(props) {
  return (
    <div className="Card-container">
      <a href={props.content.link} target="_blank" rel="noopener noreferrer">
        <video autoPlay muted loop>
          <source src={props.content.video} type="video/mp4" />
        </video>
        <img src={props.content.image} />
        <div className="card-content">
          <h2>{props.content.title}</h2>
          <p>{props.content.description}</p>
        </div>
      </a>
    </div>
  );
}
